<template>
    <div>        
        <!-- 상단 제목 -->
        <div class="topbanner">
            <h2>{{board.b_name}}</h2>
        </div>
        <!--// 상단 제목 -->        
        <!-- 메인 컨텐츠 영역 -->
        <article class="notice_contents">
            <table class="table table_notice">
                <caption>{{board.b_name}} 게시판 - 내용보기</caption>
                <thead>
                    <tr>
                        <th scope="col" colspan="2">{{content.title}}</th>
                    </tr>
                    <tr class="th_info" v-if="board.b_no != 4">
                        <td>
                            <span>작성일자 : {{content.regist_date}}</span><br />
							<span>조 회 : {{content.view_cnt}}</span>
                        </td>
                        <td class="text-right">
                            <span>작성자 : {{content.name}}</span><br />
							<span v-if="board.b_type==2">다운로드 : {{content.download_cnt}}회</span>                            
                        </td>
                    </tr>
                    <tr class="th_info" v-if="file_list.length>0">
                        <td colspan="2">
                            <span class="float-left">첨부파일 : </span>
                            <div class="alink_down">
                                <a :href="'/board/fileDown.do?f_no='+file.f_no" v-for="file in file_list" :key="file.f_no">{{file.origin_file_name}} ({{file.file_size | humanReadableFileSize}})</a>                                
                            </div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="td_textarea">
                        <td colspan="2" v-html="content.contents" v-if="board.b_reply_yn=='N'"></td>
                        <td colspan="2" v-html="content.contents.replace(/(?:\r\n|\r|\n)/g, '<br />')" v-if="board.b_reply_yn=='Y'"></td>
                    </tr>
                </tbody>
                <tfoot></tfoot>
            </table>
            <div class="form-group block_left">
                <button class="btn_common btn_short" @click="boardList">목록</button>
            </div>
            <div class="form-group block_right">
                <button class="btn_common btn_short" @click="prevNextContent(content.prev_b_c_no)" v-if="content.prev_b_c_no!=0">이전</button>
                <button class="btn_common btn_short" @click="prevNextContent(content.next_b_c_no)" v-if="content.next_b_c_no!=0">다음</button>
            </div>
            <div class="reply_wrap" v-if="board.b_reply_yn=='Y' && content.reply_flag==1">
                <table class="table table_notice_re">
                    <caption>1:1 문의하기 게시판 - 답변보기</caption>                    
                    <thead>
                        <tr>
                            <th class="h_re" scope="col">작성일자 : {{content.reply_regist_date}}</th>
                            <th class="text-right h_re" scope="col">작성자 : {{content.reply_name}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="td_textarea">
                            <td colspan="2" v-html="content.reply_contents.replace(/(?:\r\n|\r|\n)/g, '<br />')"></td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
            </div>
        </article>
        <!--// 메인 컨텐츠 영역 -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            c_no: this.$route.params.c_no,
            b_c_no: this.$route.params.b_c_no,
            board: {},
            content: {},
            file_list: []
        }
    },    
    mounted() {
        this.loadBoardInfo();
    },
    watch: {
       '$route'(to, from)  {
           this.c_no = to.params.c_no;
           this.b_c_no = to.params.b_c_no;
           this.loadBoardInfo();
       }
    },
    filters: {
        humanReadableFileSize: function(value) {
            var i = -1;
            var byteUnits = ['k', 'm', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
            do {
                value = value / 1024;
                i++;
            } while (value > 1024);

            return Math.max(value, 0.1).toFixed(1) + byteUnits[i];
        }
    },
    methods: {
        loadBoardInfo() {
            this.$http.get('/api/board/view.do', {
                params: {
                    c_no: this.c_no,
                    b_c_no: this.b_c_no                    
                }
            }).then((response) => {
                if(response.data.retval == this.CONSTANT.SUCCESS) {
                    this.board = response.data.boardInfo;
                    this.content = response.data.contentsInfo;
                    this.file_list = response.data.fileList?response.data.fileList:[];
                } else {
                    if(response.data.retval == this.CONSTANT.LOGIN_ERROR) {
                        this.$store.commit("setSession", null);
                        this.$router.push({path: "/m/login", query: {return_url: "/m/board/view/"+this.c_no+"/"+b_c_no}});
                    } else {
                        alert("게시물 조회를 실패하였습니다. [error_code:"+response.data.retval+"]");
                    }
                }
            });
        },
        boardList() {
            this.$router.push('/m/board/'+this.c_no);
        },
        prevNextContent(b_c_no) {
            this.$router.push('/m/board/view/'+this.c_no+"/"+b_c_no);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/board/View.vue